import { gql } from "@apollo/client";
import { Button } from "@mui/material";
import TextWithTooltip from "atoms/TextWithTooltip";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import Section from "molecules/Section";
import StatsTable, {
  StatsTableButtonRow,
  StatsTableHeaderCell,
  StatsTableRow,
  StatsTableStatCell,
} from "molecules/StatsTable";
import React, { useState } from "react";

export const LeaderboardTableSegmentFragment = gql`
  fragment LeaderboardTableSegmentFragment on LeaderboardTableSegment {
    title
    columns {
      shortName
      name
    }
    headColumns
    rows {
      rank
      teamId
      highlighted
      collapsible
      cells {
        statType
        value
        made
        total
      }
      headCells
    }
  }
`;

export default function LeaderboardTableSegment({ leaderboardTableSegment, collapsible = false }) {
  const [collapsed, collapsedSet] = useState(true);

  return (
    <Section title={leaderboardTableSegment.title}>
      <StatsTable
        headerColumns={["Rank", ...leaderboardTableSegment.headColumns]}
        columns={leaderboardTableSegment.columns.map((column) => (
          <TextWithTooltip key={column.shortName} tooltip={column.name}>
            {column.shortName}
          </TextWithTooltip>
        ))}
      >
        {leaderboardTableSegment.rows
          .filter((row) => !row.collapsible || !collapsed || !collapsible)
          .map((row, rowIndex) => (
            // NOTE: row.highlighted is calculated in LeaderboardTableSegment graphql. But we decide not to show row as highlighted in new leaderboard.
            <StatsTableRow key={row.headCells.join("|")} rowIndex={rowIndex}>
              <StatsTableHeaderCell>{row.rank}</StatsTableHeaderCell>
              {row.headCells.map((cell, cellIndex) => (
                <StatsTableHeaderCell key={cellIndex}>{cell}</StatsTableHeaderCell>
              ))}
              {leaderboardTableSegment.columns.map((column, columnIndex) => (
                <StatsTableStatCell key={columnIndex} stat={row.cells[columnIndex]} />
              ))}
            </StatsTableRow>
          ))}
        {collapsible && !!leaderboardTableSegment.rows.find((r) => r.collapsible) && (
          <StatsTableButtonRow>
            <Button
              fullWidth
              color="inherit"
              onClick={() => collapsedSet(!collapsed)}
              style={{
                textTransform: "uppercase",
                fontFamily: FONT_FAMILY_GRAPHIK,
                fontWeight: 600,
                fontSize: 10,
              }}
            >
              {collapsed ? "Show More" : "Show Less"}
            </Button>
          </StatsTableButtonRow>
        )}
      </StatsTable>
    </Section>
  );
}
